import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  IPreviewTemplateModalConfig,
  PreviewTemplateModalComponent,
} from '@meeting/components/preview-template-modal/preview-template-modal.component';
import {
  ConfirmationModalComponent,
  IConfirmationModalConfig,
} from '@shared/modals/confirmation/confirmation.modal';
import {
  IPendingChangesModalConfig,
  PendingChangesModalComponent,
} from '@shared/modals/pending-changes/pending-changes.modal';

export interface IBaseModalConfig {
  size?: TModalSize;
}

export type TModalSize = '448px' | '684px' | '920px';

@Injectable({
  providedIn: 'root',
})
export class ModalsBaseService {
  private readonly _defaultModalSize: TModalSize = '684px';

  constructor(private readonly _dialog: MatDialog) {}

  openPendingChangesModal$(config?: IPendingChangesModalConfig) {
    return this._dialog
      .open(PendingChangesModalComponent, {
        width: config?.size ?? this._defaultModalSize,
        data: config,
        panelClass: 'no-padding',
      })
      .afterClosed();
  }

  openConfirmationModal$(config?: IConfirmationModalConfig) {
    return this._dialog
      .open(ConfirmationModalComponent, {
        autoFocus: false,
        width: config?.size ?? this._defaultModalSize,
        data: config,
        panelClass: 'no-padding',
      })
      .afterClosed();
  }

  openPreviewTemplateModal$(config?: IPreviewTemplateModalConfig) {
    return this._dialog
      .open(PreviewTemplateModalComponent, {
        width: this._defaultModalSize,
        data: config,
        panelClass: 'no-padding',
      })
      .afterClosed();
  }
}
